import { combineActions, handleActions } from 'redux-actions'

import { resetContentState } from '@tabeeb/modules/shared/content/actions'
import * as rawActions from '../actions'
import { dialogItems } from '../services/dialogItems'

const defaultState = dialogItems.unset

export default handleActions(
  {
    [rawActions.setContentTrashBinDialogItem](state, action) {
      return action.payload
    },
    [combineActions(rawActions.resetContentTrashBinDialogItem, resetContentState)](state, action) {
      return defaultState
    },
  },
  defaultState
)
